import BccRwdBanner from 'components/Bcc/BccRwdBanner/BccRwdBanner';

export default BccRwdBanner;
